import { buildUrl } from './Utils'

export const GET_BOOKING = (bookingId: string): string =>
  buildUrl(`/api/public/bookings/manage/${bookingId}/`)

export const VISITOR_BOOKINGS = buildUrl(`/api/public/bookings/`)
